import { AdjusterfileState } from "./types";

export const defaultState = (): AdjusterfileState => {
  return {
    editing: null,
    makingApiRequest: false,
    lastUpdate: new Date(),
    adjusterfiles: [],
    links: {}
  };
};

export const state = defaultState();
